<h2 mat-dialog-title>{{ title | translate }}</h2>
<mat-dialog-content>{{ message | translate }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngFor="let action of actions" [color]="action.colored ? 'primary': 'default'" mat-button (click)="onAction(action.label)">{{ action.label | translate }}</button>
</mat-dialog-actions>
